import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { IGenericResponse } from 'src/app/common/interface/generic-response.interface';
import { IGlobalInstance } from 'src/app/common/interface/nav-link.interface';
import { BaseHttpService } from 'src/app/shared/services/base-http/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalInstancesService {
  private currentGlobalInstance: BehaviorSubject<string | null>;
  private libraryPageInstanceURL: BehaviorSubject<string | null>;

  constructor(private readonly httpService: BaseHttpService) {
    this.currentGlobalInstance = new BehaviorSubject(null);
    this.libraryPageInstanceURL = new BehaviorSubject(null);
  }

  /**
   * GetGlobalInstances: Retrieves the global instances from the platform.
   *
   * @returns {Observable<IGlobalInstance[]>}
   */
  getGlobalInstances = (): Observable<IGlobalInstance[]> =>
    this.httpService.get(`platform/global-instances`).pipe(
      map((res: IGenericResponse) => (res?.status == 200 ? res?.data : [])),
      catchError((error) => throwError(() => error))
    );

  /**
   * SetCurrentGlobalInstance: Sets the current global instance data.
   *
   * @param {string} data
   */
  setCurrentGlobalInstance = (data: string | null): void =>
    this.currentGlobalInstance.next(data);

  /**
   * SetCurrentLibraryPageInstanceURL: Sets the library page instance URL.
   * @param {string} data
   */
  setCurrentLibraryPageInstanceURL = (data: string | null): void =>
    this.libraryPageInstanceURL.next(data);

  /**
   * GetCurrentGlobalInstance: Retrieves the current global instance as an observable.
   *
   * @returns {Observable<GlobalInstance>}
   */
  getCurrentGlobalInstance = (): Observable<string | null> =>
    this.currentGlobalInstance.asObservable();

  /**
   * GetCurrentLibraryPageInstanceURL: Retrieves the current library page instance URL as an observable.
   * @returns {Observable<string>}
   */
  getCurrentLibraryPageInstanceURL = (): Observable<string | null> =>
    this.libraryPageInstanceURL.asObservable();
}
